import { Toast } from "../../js/toast.73af8352e0da.js";

const startNewSearchModal = document.getElementById("start-new-search-modal");

if (startNewSearchModal) {
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-action='clear-search-data']");
    if (!trigger) {
      return;
    }

    event.preventDefault();
    startNewSearchModal.showModal();
  });

  startNewSearchModal.addEventListener("click", (event) => {
    const clickedReset = event.target.closest("[data-reset-search-data]");
    if (clickedReset) {
      try {
        window.localStorage.clear();
        window.sessionStorage.clear();
      } catch (e) {
        // fail silently if storage is inaccessible
        return;
      }
    }
  });

  startNewSearchModal.addEventListener("htmx:afterOnLoad", () => {
    startNewSearchModal.close();
    const toast = new Toast();
    toast.showToast();
  });
}
